import styled from "@emotion/styled"
import { Button, Text, TextInputField, theme } from "@pallet-hq/hegel"
import { FlexColumn } from "components/atoms"
import OrDivider from "components/Modals/LoginModal/OrDivider"
import SocialLogins from "components/SocialLogins"
import { Form, useFormikContext } from "formik"
import { useSyncAuthFieldsFromFormik } from "components/Modals/OnboardingModal/hook"
import { EmailField } from "@pallet/components/fields/Email"

type FormViewProps = {
    setLoggingIn: (value: boolean) => void
}

const FormView = ({ setLoggingIn }: FormViewProps) => {
    const { isSubmitting } = useFormikContext()

    useSyncAuthFieldsFromFormik()

    return (
        <Form>
            <Text variant="titleMedium" mb="large">
                Log in to your account
            </Text>
            <InputSection>
                <EmailField width="100%" />
                <TextInputField
                    type="password"
                    label="Password"
                    name="password"
                    placeholder="Enter password"
                    width="100%"
                />
            </InputSection>
            <Button
                type="submit"
                size="large"
                width="100%"
                loading={isSubmitting}
                mt="medium"
                mb="small"
            >
                Sign in with Pallet
            </Button>
            <Button
                type="button"
                variant="secondary"
                size="large"
                width="100%"
                mb="32px"
                disabled={isSubmitting}
                onClick={() => setLoggingIn(false)}
            >
                Create account
            </Button>
            <OrDivider />
            <SocialLogins />
        </Form>
    )
}

export default FormView

const InputSection = styled(FlexColumn)`
    gap: ${theme.space.small};
`
